
const Api = {
    release: {
        user: 'https://user.customer.artsmrkts.com/api',
        payment: 'https://payment.customer.artsmrkts.com/api'
    },
    debug: {
       user: 'https://user.customer.artsmrkts.com/api',
        payment: 'https://payment.customer.artsmrkts.com/api'
        // user: 'https://localhost:44346/api',
        // payment: 'https://localhost:44392/api'
        // user: 'https://user.customer.artsmrkts.com/api',
        // payment: 'https://payment.customer.artsmrkts.com/api'
    }
}

export const Config = {
    /**
     * [GENERAL]
     */
    debug: /param/.test(function (param) { }),
    /**
     * [LANGUAGE]
     */
    language: {
        default: 'en',
        defaultFile: require('../assets/lang/en'),
        list: [
            // {
            //     key: 'tr',
            //     icon: 'tr-flag.svg',
            //     text: 'Turkish'
            // },
            {
                key: 'en',
                icon: 'uk-flag.svg',
                text: 'English'

            },
            // {
            //     key: 'cn',
            //     icon: 'cn-flag.svg',
            //     text: 'Chinese'
            // }
        ]
    },
    /**
     * [SERVICE]
     */
    service: {
    },
    /**
     * [UTILITIES]
     */
    utilities: {
        loadingAuth: () => (document.getElementById("root").classList.toggle("loading-auth")),
        loadingFetch: () => (document.getElementById("root").classList.toggle("loading-fetch")),
        serviceUser: (url) => (Config.debug ? Api.debug.user.concat(url) : Api.release.user.concat(url)),
        servicePayment: (url) => (Config.debug ? Api.debug.payment.concat(url) : Api.release.payment.concat(url)),
        authorizedHeader: () => {

            let user = JSON.parse(localStorage.getItem('user'));

            if (user && user.token) {
                return { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + user.token };
            } else {
                return { 'Content-Type': 'application/json' };
            }
        },
        user: () => (JSON.parse(localStorage.getItem('user'))),
        userToken: () => (Config.utilities.user.token)
    }

}

// LOAD SERVICE URL
Config.service = {
    /** 
     * [USER] 
    */
    user: {
        xsrf: Config.utilities.serviceUser('/xsrftoken'),
        login: Config.utilities.serviceUser('/personnel/user/login'),
        authenticated: Config.utilities.serviceUser('/user/authenticated'),
        dashboard: Config.utilities.serviceUser('/personnel/user/dashboard'),
        settings: Config.utilities.serviceUser('/personnel/user/settings'),
        saveSettings: Config.utilities.serviceUser('/personnel/user/savesettings'),
        profile: Config.utilities.serviceUser('/personnel/user/profile'),
        saveProfile: Config.utilities.serviceUser('/personnel/user/saveprofile'),
        recoverPassword: Config.utilities.serviceUser('/personnel/user/recoverpassword'),
        addressWhiteList: Config.utilities.serviceUser('/personnel/addressWhiteList'),
        tfagenerate: Config.utilities.serviceUser('/personnel/user/Generate2FA'),
        tfaverify: Config.utilities.serviceUser('/personnel/user/Verify2FA'),
        tfastatus: Config.utilities.serviceUser('/personnel/user/GetTFAStatus'),
        withdrawtfaverify: Config.utilities.serviceUser('/personnel/user/WithdrawVerify2FA')
    },
    transferOptions: {
        // Payment Services
        list: Config.utilities.serviceUser('/personnel/transferoptions/list'),
        detail: Config.utilities.serviceUser('/personnel/transferoptions/detail'),
        save: Config.utilities.serviceUser('/personnel/transferoptions/save'),
        // PSP Rules
        rules: Config.utilities.serviceUser('/personnel/transferoptions/rules'),
        ruleSave: Config.utilities.serviceUser('/personnel/transferoptions/saverule'),
        getRule: Config.utilities.serviceUser('/personnel/transferoptions/detailrule'),
        deleteRule: Config.utilities.serviceUser('/personnel/transferoptions/deleterule'),
        // PSP Daily Limit
        dailyLimit: Config.utilities.serviceUser('/personnel/transferoptions/dailylimits'),
        dailyLimitSave: Config.utilities.serviceUser('/personnel/transferoptions/savedailylimit'),
        // White List
        whiteList: Config.utilities.serviceUser('/personnel/transferoptions/whitelist'),
        whiteListDetail: Config.utilities.serviceUser('/personnel/transferoptions/detailwhitelist'),
        whiteListSave: Config.utilities.serviceUser('/personnel/transferoptions/savewhitelist'),
        whiteListDelete: Config.utilities.serviceUser('/personnel/transferoptions/deletewhitelist'),
        // Black List
        blackList: Config.utilities.serviceUser('/personnel/transferoptions/BlackList'),
        blackListEdit: Config.utilities.serviceUser('/personnel/transferoptions/DetailBlackList'),
        blackListSave: Config.utilities.serviceUser('/personnel/transferoptions/SaveBlackList'),
        blackListDelete: Config.utilities.serviceUser('/personnel/transferoptions/DeleteBlackList'),
        // Page Role
        roles: Config.utilities.serviceUser('/personnel/transferoptions/Roles'),
        roleEdit: Config.utilities.serviceUser('/personnel/transferoptions/DetailRole'),
        roleSave: Config.utilities.serviceUser('/personnel/transferoptions/SaveRole'),
        roleDelete: Config.utilities.serviceUser('/personnel/transferoptions/DeleteRole'),
        // Global
        transferOptionList: Config.utilities.serviceUser('/personnel/ListTransferOptions'),
        countryList: Config.utilities.serviceUser('/personnel/ListCountry'),
        currencyList: Config.utilities.serviceUser('/personnel/ListCurrency')
    },
    deposit: {
        history: Config.utilities.serviceUser('/personnel/deposit/history'),
        detail: Config.utilities.serviceUser('/personnel/deposit/detail'),
        saveComment: Config.utilities.serviceUser('/personnel/comment')
    },
    withdraw: {
        history: Config.utilities.serviceUser('/personnel/withdraw/history'),
        detail: Config.utilities.serviceUser('/personnel/withdraw/detail'),
        saveComment: Config.utilities.serviceUser('/personnel/comment')
    },
    internalTransfer: {
        history: Config.utilities.serviceUser('/personnel/internaltransfer/history'),
        detail: Config.utilities.serviceUser('/personnel/internaltransfer/detail'),
        saveComment: Config.utilities.serviceUser('/personnel/comment')
    },
    actions: {
        confirm: Config.utilities.servicePayment('/payment/confirm'),
        cancel: Config.utilities.servicePayment('/payment/cancel'),
        pending: Config.utilities.servicePayment('/payment/pending'),
        setStatus: Config.utilities.servicePayment('/payment/setstatus'),
    },
    common: {
        user: {
            list: Config.utilities.serviceUser('/personnel/userlist'),
            detail: Config.utilities.serviceUser('/personnel/userdetail'),
            editsave: Config.utilities.serviceUser('/personnel/usersave'),
            delete: Config.utilities.serviceUser('/personnel/userdelete'),
        },
        currency: {
            getList: Config.utilities.serviceUser('/personnel/currencylist'),
            update: Config.utilities.serviceUser('/personnel/updatecurrency')
        }
    },
    crypto: {
        list: Config.utilities.serviceUser('/personnel/wallet/transactions'),
        listERC20: Config.utilities.serviceUser('/personnel/wallet/transactionsERC20'),
        portfolioERC20: Config.utilities.servicePayment('/notify/erc20/Portfoliomanager/'),
        portfolioTRC20: Config.utilities.servicePayment('/notify/trc20/Portfoliomanager/'),
        listTRC20: Config.utilities.serviceUser('/personnel/wallet/transactionsTRC20'),
        listSubTRC20: Config.utilities.serviceUser('/personnel/wallet/subwalletdetailTRC20'),
        listSubERC20: Config.utilities.serviceUser('/personnel/wallet/subwalletdetailERC20'),
        trc20CommissionFeeList: Config.utilities.serviceUser('/personnel/ListMetaStatusFee'),
        trc20CommissionFeeUpdate:Config.utilities.serviceUser('/personnel/UpdateMetaStatusFeeValue'),
        qrcode: Config.utilities.serviceUser('/personnel/qrcode'),
        coinWithdraw: Config.utilities.serviceUser('/personnel/wallet/withdraw'),
        coinWithdrawERC20: Config.utilities.serviceUser('/personnel/wallet/withdrawERC20'),
        coinWithdrawTRC20: Config.utilities.serviceUser('/personnel/wallet/withdrawTRC20')
    },
    document: {
        list: Config.utilities.serviceUser('/personnel/document/list'),
        detail: Config.utilities.serviceUser('/personnel/document/detail'),
        action: Config.utilities.serviceUser('/personnel/document/action')

    }
}
